export const PHONE = "1300 009 247";
export const PHONE_HREF = "tel:1300009247";
export const EMAIL = "hello@agencyhq.net.au";

export const NAV_LINKS = [
  { id: "how", label: "How It Works" },
  { id: "support", label: "Support" },
  { id: "calculator", label: "Earnings Calculator" },
  { id: "stories", label: "Success Stories" },
  { id: "team", label: "Leadership Team" },
  { id: "faqs", label: "FAQs" },
  { id: "contact", label: "Contact" },
];

export const CREDIBILITY = [
  "Build your own brand",
  "Retain up to 95% commission",
  "No establishment costs",
  "Full operational support",
  "Australia-wide network",
];

export const MARQUEE_ITEMS = [
  "Eagle CRM",
  "DocuSign",
  "Rate My Agent",
  "CoreLogic",
  "ID4ME",
  "Domain",
  "REA",
  "Realforms",
  "HQ Marketing Portal",
];

export const OPERATING_MODELS = [
  {
    tag: "01",
    title: "Your own independent brand",
    desc: "Operate under your own name, keep your local reputation and your identity — with the entire Agency HQ platform running quietly behind it.",
  },
  {
    tag: "02",
    title: "Co-branded with Agency HQ",
    desc: "Blend your personal brand with the strength of the Agency HQ name. Ideal when you want network credibility while you grow.",
  },
  {
    tag: "03",
    title: "The Agency HQ brand",
    desc: "Step straight into an established boutique brand with systems, recognition and support from day one.",
  },
];

export const SUPPORT_ITEMS = [
  { icon: "FileText", title: "Agency agreements & contracts" },
  { icon: "ClipboardList", title: "Listing administration" },
  { icon: "PenTool", title: "Electronic forms & signatures" },
  { icon: "Landmark", title: "Trust accounting & commission processing" },
  { icon: "ShieldCheck", title: "Compliance & file checking" },
  { icon: "BadgeCheck", title: "AML support & workflows" },
  { icon: "Palette", title: "Marketing coordination & graphic design" },
  { icon: "MonitorSmartphone", title: "CRM, property portals & technology" },
  { icon: "BarChart3", title: "CoreLogic & property data" },
  { icon: "Receipt", title: "Supplier & advertising invoice administration" },
  { icon: "GraduationCap", title: "Agent onboarding & training" },
  { icon: "Compass", title: "Business planning & mentoring" },
  { icon: "Sparkles", title: "Personal brand development" },
  { icon: "Building2", title: "Property management & rent-roll support" },
];

export const COMPARE = {
  columns: ["Traditional franchise", "Completely independent", "Agency HQ-supported"],
  rows: [
    { label: "Setup costs", values: ["High establishment fees", "Full agency setup at your cost", "No establishment costs"] },
    { label: "Ongoing overhead", values: ["Franchise fees on every sale", "Every system and licence on you", "One low monthly membership"] },
    { label: "Staff requirements", values: ["You employ admin staff", "You employ the whole team", "None — our people are your back office"] },
    { label: "Brand flexibility", values: ["Locked to the franchisor brand", "Total freedom, total workload", "Own brand, co-branded or Agency HQ"] },
    { label: "Administration & compliance", values: ["Run by you or your hires", "You build it all yourself", "Done for you, file by file"] },
    { label: "Commission retention", values: ["Typically 70–80%", "Up to 100% — after all costs", "Retain up to 95%"] },
  ],
};

export const FEATURED_VIDEOS = [
  { file: "video-explained.mp4", title: "Agency HQ explained" },
];

export const STORIES = [
  {
    key: "peter",
    name: "Peter Sayers",
    tag: "Agency HQ member",
    quote: "Excellent service.",
    photo: "agent-peter.jpg",
    video: "video-peter.mp4",
  },
  {
    key: "ronni",
    name: "Ronni Leigh",
    tag: "Agency HQ member",
    quote: "Great experience, communication is so good and transparent.",
    photo: "agent-ronni.jpg",
    video: "video-ronni.mp4",
  },
  {
    key: "kickstart",
    name: "Kickstart",
    tag: "Kickstart program",
    quote: null,
    photo: null,
    video: "video-event.mp4",
  },
];

export const TEAM = [
  {
    name: "Mark Morrison & the Agency HQ admin team",
    role: "Founder & CEO · Client Success · Sales Administration",
    photo: "leader-team.jpg",
    wide: true,
    bio: "Mark founded Agency HQ to give experienced agents a genuine alternative to franchises and going it alone. He stays close to every member relationship — working directly with principals on structure, growth and the bigger decisions — while the admin team he built, our Client Success Champions and Sales Administration specialists, run the day-to-day behind every member business.",
  },
  {
    name: "Yasemin Kemal",
    role: "Director of Property Management",
    photo: "leader-yasemin.jpg",
    bio: "Yasemin leads property management and rent-roll support — from tenant screening and lease administration through to day-to-day workflows — so members can build a recurring-income rent roll without ever employing a property management department.",
  },
];

export const WHY = [
  { title: "Build an asset", desc: "Build a business with real value — not simply earn a wage on commission." },
  { title: "Retain more", desc: "Retain more of the commission you generate — up to 95% of what you earn." },
  { title: "Keep your identity", desc: "Keep your name, your brand and your local reputation exactly as they are." },
  { title: "No back-office payroll", desc: "Avoid employing an entire back-office team to support your sales." },
  { title: "Practical, personal support", desc: "Experienced people who actually do the work — not a call centre." },
  { title: "Your own rent roll", desc: "Create a recurring-income rent roll with property management behind you." },
  { title: "Grow beyond you", desc: "Build a business that can grow, be scaled, and one day be sold." },
];

export const FAQS = [
  {
    q: "Can I operate under my own brand?",
    a: "Yes. You can run under your own independent brand, co-brand with Agency HQ, or use the Agency HQ name. Many members keep the local reputation they have spent years building — the platform works behind it.",
  },
  {
    q: "What commission can I retain?",
    a: "Members retain up to 95% of the commission they generate. Your exact rate depends on how you choose to operate — it is set out clearly before you join, with no hidden deductions.",
  },
  {
    q: "What are the fees?",
    a: "A low monthly administration fee from $250 covers access to the platform, the team and the technology. There are no establishment costs and no franchise-style fees on your commissions. We walk through exact numbers in your confidential conversation.",
  },
  {
    q: "Do I need to employ administration staff?",
    a: "No. Trust accounting, contracts, listing administration, compliance, invoicing and marketing coordination are all handled by the Agency HQ team. If you already employ staff, they are welcome too.",
  },
  {
    q: "What systems and portals are included?",
    a: "A full CRM, listing and contract systems, electronic forms and signatures, trust accounting, property portals, CoreLogic property data and marketing tools — all included in your membership.",
  },
  {
    q: "Can Agency HQ support an existing agency?",
    a: "Yes. Small teams and independent agencies use Agency HQ to replace their back office — keeping their brand and clients while handing over administration, compliance and accounting.",
  },
  {
    q: "Can I build my own rent roll?",
    a: "Yes, and it is one of the strongest reasons members join. Property management and rent-roll support means you can build recurring income without employing a property management department.",
  },
  {
    q: "How long does onboarding take?",
    a: "Onboarding is structured and personal — brand, systems, training and templates are set up with you. Most members are operating quickly; the exact timeline is mapped in your first conversation.",
  },
  {
    q: "Is my enquiry confidential?",
    a: "Completely. Enquiries are seen only by the small recruitment team, we never contact your current agency, and there is no obligation attached to a conversation.",
  },
  {
    q: "What states does Agency HQ operate in?",
    a: "Agency HQ supports members Australia-wide — a national network with local presence, across every state and territory.",
  },
];

export const STATES = ["NSW", "VIC", "QLD", "SA", "WA", "TAS", "NT", "ACT", "Other"];

export const INTEREST_OPTIONS = [
  { value: "own_brand", label: "My own brand" },
  { value: "agency_hq_brand", label: "The Agency HQ brand" },
  { value: "existing_agency", label: "Support for my existing agency" },
  { value: "unsure", label: "Not sure yet — talk me through it" },
];
